<p-menubar *ngIf="showHeader">
    <ng-template pTemplate="start">
        <div class="start-menu">
            <div class="icon">
                <img src="assets/images/myappicon-shaded.png" class="mr-2" height="60px">
            </div>
            <ng-container *ngIf="!deviceManager.isDesktop || !deviceManager.isWideEnoughForDualPane">
                <button #btn type="button" pButton icon="pi pi-list" (click)="menu.toggle($event)"></button>
                <p-slideMenu #menu [model]="menuItems" [popup]="true" [viewportHeight]="250"></p-slideMenu>
            </ng-container>
            <p-menubar *ngIf="deviceManager.isDesktop && deviceManager.isWideEnoughForDualPane" [model]="menuItems"></p-menubar>
        </div>
    </ng-template>
    <ng-template pTemplate="end">
<!--        <button *ngIf="!showOrganizationSelector" pButton pRipple type="button" class="p-button-text legacy-portal-button" [label]="(deviceManager.isMobile ? '' : 'Go to ') + 'Legacy Portal'" (click)="onGoToLegacyPortal()"></button>-->
        <p-dropdown *ngIf="showOrganizationSelector && groups.length > 1" #groupDropdown
                    [scrollHeight]="'500px'"
                    [options]="groups"
                    [(ngModel)]="group"
                    (onHide)="onGroupDropdownClosed()"
                    styleClass="group-list-dropdown"
                    placeholder="Select a Group"></p-dropdown>
        <p-dropdown #orgDropdown
                    *ngIf="showOrganizationSelector"
                    [scrollHeight]="'500px'"
                    [options]="organizations"
                    optionLabel="label"
                    [filter]="true"
                    filterBy="label"
                    [(ngModel)]="organization"
                    (onHide)="onOrganizationDropdownClosed()"
                    styleClass="org-list-dropdown"
                    placeholder="Select an Organization"></p-dropdown>
        <!--        <input type="text" pInputText placeholder="Search">-->
        <button type="button" pButton class="p-button-outlined user-icon-button" (click)="userMenu.toggle($event)">
            <fa-icon icon="user" size="1x"></fa-icon>
        </button>
        <p-menu #userMenu [popup]="true" [model]="userMenuItems" styleClass="user-menu-items" (onShow)="userMenuShown = true" (onHide)="userMenuShown = false"></p-menu>
    </ng-template>
</p-menubar>


<p-dialog
        *ngIf="displayDocument"
        [(visible)]="displayDocument"
        [modal]="true"
        [appendTo]="'body'"
        [closable]="true"
        [showHeader]="true"
        [draggable]="false">
    <p-header>
        {{ MyCampAppConstants.AppName }} - {{ documentName }}
    </p-header>

    <mycampapp-document-viewer [documentType]="documentType"></mycampapp-document-viewer>
</p-dialog>
